/**
 * useStartPulse - the instrument's two-second start (Squad Mode stage 8, ruled 2026-10-23): when this brother enters
 * Squad Mode, starts an ability or joins one, here, now. Never replayed (`usePassing`). Motion off, the stylesheet
 * holds it still.
 *
 * @param killTeam - his Squad Mode, off the plate's target
 * @returns true for the two seconds after such a change
 */
import usePassing from './usePassing';
import type { KillTeamState } from '../../engine/roster/types';

/** In Squad Mode, with the keys of the abilities he is in; empty when Solo. */
const startKey = (k: KillTeamState | undefined) =>
  k?.on ? ['on', ...(k.joined ?? []).map((j) => j.key)].join(',') : '';

/** A start: in Squad Mode now, and either he was not, or he is in an ability he was not in. */
function started(before: string, now: string): boolean {
  if (!now) return false;
  const had = new Set(before.split(','));
  return !before || now.split(',').some((k) => !had.has(k));
}

export default function useStartPulse(killTeam: KillTeamState | undefined): boolean {
  return usePassing(startKey(killTeam), started, 2000);
}
